<template>
  <AsyncPage
    :loader="useSupportLoader"
    :page-component="Support"
  />
</template>

<script setup lang="ts">
import { defineAsyncComponent } from "vue";
import { useSupportLoader } from "./Support.loader.ts";
import { AsyncPage } from "@saflib/vue/components";
const Support = defineAsyncComponent(
  () => import("./Support.vue"),
);
</script>
